// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen` from
// x-flags.doRenderReactQueryMutateHook on POST /block/add.

import {
  useMutation,
  useQueryClient,
  type QueryClient,
  type UseMutationOptions,
} from "@tanstack/react-query";
import type {
  typeBlockAddBody,
  typeBlockAddOutput200,
} from "../../sdk/block/postBlockAdd";
import useCallSdk from "../../sdk-helpers/useCallSdk";

type Options = Omit<
  UseMutationOptions<typeBlockAddOutput200, unknown, typeBlockAddBody, unknown>,
  "mutationFn"
>;

let invalidationTimer: ReturnType<typeof setTimeout> | null = null;

// 150ms of silence before invalidating: a burst of mutations (a row action
// repeated across a table selection) triggers one refetch, not one per call.
export function invalidateRelated({
  queryClient,
}: {
  queryClient: QueryClient;
}): void {
  if (invalidationTimer) {
    clearTimeout(invalidationTimer);
  }
  invalidationTimer = setTimeout(() => {
    void queryClient.invalidateQueries({
      queryKey: ["post:block:blockList", "svc:profile-api"],
    });
    void queryClient.invalidateQueries({
      queryKey: ["post:profile:profileGetForAccount", "svc:profile-api"],
    });
    void queryClient.invalidateQueries({
      queryKey: ["post:fanFollow:fanFollowRequestsList", "svc:profile-api"],
    });
    void queryClient.invalidateQueries({
      queryKey: ["post:fanFollow:fanFollowFollowersList", "svc:profile-api"],
    });
    void queryClient.invalidateQueries({
      queryKey: ["post:fanFollow:fanFollowFollowingList", "svc:profile-api"],
    });
    void queryClient.invalidateQueries({
      queryKey: ["post:fanFollow:fanFollowRequestCount", "svc:profile-api"],
    });
  }, 150);
}

export default function useBlockAdd(options?: Options) {
  const { callSdk } = useCallSdk();
  const queryClient = useQueryClient();
  const resolvedOptions = options ?? {};

  return useMutation({
    mutationFn: callSdk().postBlockAdd,
    ...resolvedOptions,
    // TanStack Query v5 hands onSuccess four arguments
    // (data, variables, onMutateResult, context). Forward all four. Dropping
    // the last one makes the caller's own onSuccess a type error at every
    // generated mutation hook.
    onSuccess: (data, variables, onMutateResult, context) => {
      resolvedOptions.onSuccess?.(data, variables, onMutateResult, context);
      invalidateRelated({ queryClient });
    },
  });
}
